// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Libya from '../_raw/flag/icon_flag_libya.png';

export default () => <img src={Libya} alt="Libya" />;
